<script setup lang="ts">
import SaveButton from "@/components/SaveButton.vue";
import type { MutationStatus } from "@tanstack/vue-query";
import { ref, toRaw } from "vue";
import SettingsFormFields from "./SettingsFormFields.vue";
import type { Settings } from "./types";

const props = defineProps<{
  settings: Settings;
  updateSettingsStatus: MutationStatus;
}>();

defineEmits<{
  update: [settings: Settings];
}>();

const settings = ref(structuredClone(toRaw(props.settings)));
</script>

<template>
  <form class="box column" @submit.prevent="$emit('update', settings)">
    <SettingsFormFields v-model="settings" />
    <div class="row row-end">
      <SaveButton :saving-status="updateSettingsStatus">Speichern</SaveButton>
    </div>
  </form>
</template>
